import { Camera, Upload } from "lucide-react";
import { isValidFileSize, isValidImageFile } from "../../utils/fileUtils";

const FileUpload = ({
  fileInputRef,
  onFileChange,
  onCapture,
  mode,
  isCapturing,
  capturedImage,
  buttonText,
}) => {
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!isValidImageFile(file)) {
        alert("Please select an image file (JPG, PNG, etc.)");
        return;
      }

      // Validate file size (max 10MB)
      if (!isValidFileSize(file, 10)) {
        alert("File size must be less than 10MB");
        return;
      }

      onFileChange(file);
    }
  };

  const triggerFileUpload = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileUpload}
        className="hidden"
      />

      <button
        onClick={mode === "camera" ? onCapture : triggerFileUpload}
        disabled={isCapturing}
        className="btn-primary flex align-center gap-2 justify-center flex-1 w-full mt-4"
      >
        {mode === "camera" ? (
          <>
            <Camera size={20} />
            {isCapturing ? "Capturing..." : buttonText || "Capture"}
          </>
        ) : (
          <>
            <Upload size={20} />
            {buttonText || "Choose File"}
          </>
        )}
      </button>
    </>
  );
};

export default FileUpload;
